import ArticleIcon from '@mui/icons-material/Article';
import { Box, Chip, Divider, Paper, Stack, Typography } from '@mui/material';
import { IEquipment } from 'features/inventory/equipments/types';
import { useTranslation } from 'react-i18next';
import { StatusOption } from 'shared/types/general';
import { cardThemeStyles as styles } from './cardStyle';

interface InfoItemProps {
  label: string;
  value: string;
}

const InfoItem = ({ label, value }: InfoItemProps) => (
  <Box sx={{ flex: '1 1 45%', minWidth: 200 }}>
    <Typography variant="caption" color="text.secondary" component="div">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={500}>
      {value}
    </Typography>
  </Box>
);

interface BaseInfoCardProps {
  equipment: IEquipment;
}

export const BaseInfoCard = ({ equipment }: BaseInfoCardProps) => {
  const { t } = useTranslation();
  const translationPrefix = 'entities.equipment';

  const getStatusLabel = (status?: string | StatusOption): string => {
    if (!status) return '—';
    return typeof status === 'string' ? status : status.display_name;
  };

  return (
    <Paper elevation={1} sx={styles.cardPaper}>
      {/* Intestazione Card */}
      <Box sx={styles.headerContainer}>
        <Box sx={styles.iconCircle}>
          <ArticleIcon />
        </Box>
        <Typography variant="h6" sx={styles.headerTitle}>
          {t('global.info')}
        </Typography>
        <Divider orientation="vertical" flexItem sx={{ ml: 1 }} />
        <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
          {t('global.status')}
        </Typography>
        <Chip label={getStatusLabel(equipment?.status)} size="small" sx={styles.statusChip} />
      </Box>

      {/* Contenuto Card */}
      <Stack spacing={4}>
        <Box sx={styles.flexRowWrap}>
          <InfoItem label={t('global.description')} value={equipment?.description} />
          <InfoItem
            label={t(`${translationPrefix}.serial_number`)}
            value={equipment?.serial_number}
          />
        </Box>

        <Box sx={styles.flexRowWrap}>
          <InfoItem label={t(`${translationPrefix}.position`)} value={equipment?.position} />
          <InfoItem label={t(`${translationPrefix}.supplier`)} value={equipment?.supplier} />
        </Box>
      </Stack>
    </Paper>
  );
};
